import { Box, Typography } from "@mui/material";
import React from "react";
import { useProcessingActivityStatisticsStyles } from "../processingActivityStatistics.styles";
import { useTranslation } from "../../../localization/useTranslation";
import DotLegalPaper from "../../../common/components/dotLegalPaper/DotLegalPaper";

export interface CompletedCasesProps {
    completedCases: number | undefined;
}

function CompletedCases(props: CompletedCasesProps) {
    const styles = useProcessingActivityStatisticsStyles();
    const { translateString } = useTranslation();
    return (
        <Box>
            <DotLegalPaper backgroundColor="lightGreen" fullHeight>
                <Typography sx={styles.header}>{translateString("completedCases")}</Typography>
                <Typography sx={styles.body}>{props?.completedCases}</Typography>
            </DotLegalPaper>
        </Box>
    );
}

export default CompletedCases;
